import '@vanilla-extract/css/vanilla.virtual.css?ve-css=QGtleWZyYW1lcyBfMzFkZHczMSB7CiAgMCUgewogICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7CiAgfQogIDEwMCUgewogICAgdHJhbnNmb3JtOiByb3RhdGUoMzYwZGVnKTsKICB9Cn0';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8zMWRkdzMwIHsKICB0cmFuc2Zvcm06IHNjYWxlKDEpOwp9';
export var webkitRenderFix = '_31ddw30';
export var spin = '_31ddw31';